module.exports = __webpack_public_path__ + "img/eetlienG.5fa5ddf2.svg";